enum ConsentPermission {
    NoActiveConsent = "no-active-consent",
    ConsentGiven = "consent-given",
    ConsentRefused = "consent-refused"
}

export { ConsentPermission };
